import useLiterals from 'utils/hooks/useLiterals';
import Layout from 'components/Layout';
import AppShell from 'components/Layout/AppShell';
import Contracts from './components/Contracts';
import AccountStatements from './components/AccountStatements';
import './styles.scss';

const Documents = () => {
  const literals = useLiterals('documents');
  return (
    <Layout
      bottomMenu
      onBack
    >
      <AppShell variant='default'>
        <div className='documents'>
          <h3 className='mb-4'>{literals.contracts}</h3>
          <Contracts />
          <h3 className='my-4'>{literals.accountStatements}</h3>
          <AccountStatements />
        </div>
      </AppShell>
    </Layout>
  );
};

export default Documents;
